// extracted by mini-css-extract-plugin
export default {"heading":"Header_heading__Ai2dB","sub-heading":"Header_sub-heading__3Cj54"};